export default __webpack_public_path__ + "static/media/Caja_ancha_Focus.659c1461.svg";